import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { withNamespaces } from 'react-i18next';

const items = [
  {
    key: 'info1',
    // image: '/images/info1.png',
    // name: '新手教學',
    // description: '全球新手必看教程',
    w: 33,
    h: 49,
  },
  {
    key: 'info2',
    // image: 'images/info2.png',
    // name: '免費試玩',
    // description: '1571高品質遊戲',
    w: 46,
    h: 32,
  },
  {
    key: 'info3',
    // image: 'images/info3.png',
    // name: '快速註冊',
    // description: '立即註冊，馬上遊戲',
    w: 50,
    h: 39,
  },
  {
    key: 'info4',
    // image: 'images/info4.png',
    // name: '新手教學',
    // description: '30%高額回報',
    w: 55,
    h: 44,
  },
];

export default withNamespaces()(InfoSection);
function InfoSection(props) {
  const { t } = props;
  return (
    <div style={{ backgroundColor: '#1E3845', padding: 15 }}>
      <Container>
        <Row
          style={{
            borderColor: '#2A8FBD',
            borderWidth: 2,
            borderStyle: 'solid',
            paddingRight: 10,
            paddingLeft: 10,
          }}
        >
          {items.map((element, index) => {
            let image = `./images/${element.key}.png`;
            let name = t(`InfoSection.${element.key}.name`);
            let description = t(`InfoSection.${element.key}.description`);
            return (
              <Col key={index} style={{ marginTop: 10, marginBottom: 10 }}>
                <Row className={'justify-content-center align-items-center'}>
                  <img
                    src={image}
                    alt={name}
                    width={element.w}
                    height={element.h}
                  />
                  <Col>
                    <div style={{ color: '#2A8FBD' }}>{name}</div>
                    <div style={{ color: 'lightgray', fontSize: 10 }}>
                      {description}
                    </div>
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};
